import api from "@/config/http-client-gateway";
import { showErrorToast } from '@/kernel/alerts';


export const getNewsForAdmin = async () => {
  try {
    const response = await api.doGet('/news-for-admin');
    return response?.data;
  } catch (error) {
    console.log('Error obteniendo las noticias:', error);
    showErrorToast('Error obteniendo las noticias');
  }
}

export const getNewsForInvestors = async () => {
  try {
    const response = await api.doGet('/news');
    return response?.data;
  } catch (error) {
    console.log('Error obteniendo las noticias:', error);
  }
}

export const createNews = async (data) => {
  try {
    const response = await api.doPost('/create-news', data);
    return response?.data;
  } catch (error) {
    console.log('Error creando la noticia:', error);
    showErrorToast('Error creando la noticia');
  }
}

export const updateNews = async (data) => {
  try {
    const response = await api.doPut('/update-news', data);
    return response?.data;
  } catch (error) {
    console.log('Error actualizando la noticia:', error);
    showErrorToast('Error actualizando la noticia');
  }
}

export const deleteNews = async (data) => {
  try {
    const response = await api.doDelete('/delete-news', data);
    return response?.data;
  } catch (error) {
    console.log('Error eliminando la noticia:', error);
    showErrorToast('Error eliminando la noticia');
  }
}


